import React, { FC } from 'react';
import { BubbleButton } from '@go-client/components/BubbleUI';

type PaginateTranslationsProps = {
  type: string;
  onLoadMoreClick: () => void;
};

export const PaginateTranslations: FC<PaginateTranslationsProps> = ({ type, onLoadMoreClick }) => {
  return (
    <>
      <BubbleButton
        variant={'navy'}
        inverse
        block
        icon="rotate"
        onClick={onLoadMoreClick}
        className="uppercase text-navy text-left py-2"
      >
        Load More {type}
      </BubbleButton>
    </>
  );
};
